module.exports = __webpack_public_path__ + "static/media/map-marker-divisions-active.dead3581.svg";